import React, { useEffect } from 'react';

const AppendElements = React.forwardRef(function AppendElements({htmlElements, children, ...props}, extRef)
{
    let divRef = React.useRef();
    if(extRef) divRef = extRef;

    useEffect(() =>
    {
        if(Array.isArray(htmlElements))
        {
            for(let i=0;i<htmlElements.length;i++)
            {
                divRef.current.appendChild(htmlElements[i]);
            }
        }
        else
        {
            divRef.current.appendChild(htmlElements);
        }
        
    }, [htmlElements]);

    return <div ref={divRef} {...props}>
        {children}
    </div>
});

export default AppendElements;